// @flow
import type { FacetOption as FacetOptionType } from '../../types/FacetOption';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './SelectedCountry.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    linkText: any,
    onChange: Function,
    option: FacetOptionType,
};

const SelectedCountry = (props: Props) => {
    const { linkText, onChange, option } = props;

    return (
        <div className={styles.selectedCountry}>
            <Text secondary>{option.name}</Text>
            <div className={styles.changeCountryLink}>
                <Link className={styles.viewMore} onClick={onChange}>
                    <Text secondary>{linkText}</Text>
                </Link>
            </div>
        </div>
    );
};

export default React.memo<Props>(SelectedCountry);
